module.exports = {
	"swagger": "2.0",
	"info": {
		"version": "2017-01-26T15:33:55Z",
		"title": "Newforma Admin APIs"
	},
	"host": "api.newforma.cloud",
	"basePath": "/v1",
	"schemes": [
		"https"
	],
	"tags": [
		{
			"name": "accesskeys",
			"description": "Used for authentication."
		},
		{
			"name": "login",
			"description": "Authentication endpoint, used to retrieve AWS sigv4."
		}
	],
	"paths": {
		"/accesskeys": {
			"post": {
				"consumes": [
					"application/json"
				],
				"summary": [
					"accesskeys"
				],
				"tags": [
					"accesskeys"
				],
				"produces": [
					"application/json"
				],
				"responses": {
					"200": {
						"description": "200 response",
						"schema": {
							"$ref": "#/definitions/createAccessKeyResponse"
						},
						"headers": {
							"Access-Control-Allow-Origin": {
								"type": "string"
							}
						}
					},
					"400": {
						"description": "400 response",
						"schema": {
							"$ref": "#/definitions/RfcError"
						},
						"headers": {
							"Access-Control-Allow-Origin": {
								"type": "string"
							}
						}
					},
					"403": {
						"description": "403 response",
						"schema": {
							"$ref": "#/definitions/RfcError"
						},
						"headers": {
							"Access-Control-Allow-Origin": {
								"type": "string"
							}
						}
					},
					"500": {
						"description": "500 response",
						"schema": {
							"$ref": "#/definitions/RfcError"
						},
						"headers": {
							"Access-Control-Allow-Origin": {
								"type": "string"
							}
						}
					}
				},
				"security": [
					{
						"sigv4": []
					}
				]
			},
			"options": {
				"consumes": [
					"application/json"
				],
				"summary": [
					"accesskeys"
				],
				"tags": [
					"accesskeys"
				],
				"produces": [
					"application/json"
				],
				"responses": {
					"200": {
						"description": "200 response",
						"schema": {
							"$ref": "#/definitions/Empty"
						},
						"headers": {
							"Access-Control-Allow-Origin": {
								"type": "string"
							},
							"Access-Control-Allow-Methods": {
								"type": "string"
							},
							"Access-Control-Allow-Headers": {
								"type": "string"
							}
						}
					}
				}
			}
		},
		"/login": {
			"post": {
				"consumes": [
					"application/json"
				],
				"summary": [
					"login"
				],
				"tags": [
					"login"
				],
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"in": "body",
						"name": "loginRequest",
						"required": true,
						"schema": {
							"$ref": "#/definitions/loginRequest"
						}
					}
				],
				"responses": {
					"200": {
						"description": "200 response",
						"schema": {
							"$ref": "#/definitions/loginResponse"
						},
						"headers": {
							"Access-Control-Allow-Origin": {
								"type": "string"
							}
						}
					},
					"400": {
						"description": "400 response",
						"schema": {
							"$ref": "#/definitions/RfcError"
						},
						"headers": {
							"Access-Control-Allow-Origin": {
								"type": "string"
							}
						}
					},
					"403": {
						"description": "403 response",
						"schema": {
							"$ref": "#/definitions/RfcError"
						},
						"headers": {
							"Access-Control-Allow-Origin": {
								"type": "string"
							}
						}
					},
					"500": {
						"description": "500 response",
						"schema": {
							"$ref": "#/definitions/RfcError"
						},
						"headers": {
							"Access-Control-Allow-Origin": {
								"type": "string"
							}
						}
					}
				}
			},
			"options": {
				"consumes": [
					"application/json"
				],
				"summary": [
					"login"
				],
				"tags": [
					"login"
				],
				"produces": [
					"application/json"
				],
				"responses": {
					"200": {
						"description": "200 response",
						"schema": {
							"$ref": "#/definitions/Empty"
						},
						"headers": {
							"Access-Control-Allow-Origin": {
								"type": "string"
							},
							"Access-Control-Allow-Methods": {
								"type": "string"
							},
							"Access-Control-Allow-Headers": {
								"type": "string"
							}
						}
					}
				}
			}
		}
	},
	"securityDefinitions": {
		"sigv4": {
			"type": "apiKey",
			"name": "Authorization",
			"in": "header",
			"x-amazon-apigateway-authtype": "awsSigv4"
		}
	},
	"definitions": {
		"sharedFileSnapshot": {
			"type": "object",
			"required": [
				"fileName",
				"fileSize",
				"nrn",
				"projectName"
			],
			"properties": {
				"nrn": {
					"type": "string",
					"description": "The nrn of the file snapshot."
				},
				"fileSize": {
					"type": "integer",
					"format": "int64",
					"description": "The size of the file snapshot, in bytes."
				},
				"fileName": {
					"type": "string",
					"description": "The name of the file snapshot."
				},
				"mimeType": {
					"type": "string",
					"description": "The MIME type of the file snapshot."
				},
				"projectName": {
					"type": "string",
					"description": "The name of the project that the file snapshot belongs to."
				}
			},
			"title": "A snapshot of a shared file"
		},
		"loginResponse": {
			"type": "object",
			"properties": {
				"accessKeyId": {
					"type": "string",
					"description": "The Access Key portion of the credentials"
				},
				"secretAccessKey": {
					"type": "string",
					"description": "The Secret Access Key portion of the credentials"
				},
				"sessionToken": {
					"type": "string",
					"description": "The Session Token portion of the credentials"
				},
				"expiration": {
					"type": "string",
					"description": "The date at which these credentials will expire."
				},
				"signatureScope": {
					"type": "string",
					"description": "The scope to be used when signing a request to an authorized endpoint."
				}
			},
			"title": "Login Response"
		},
		"Empty": {
			"type": "object",
			"title": "Empty Schema"
		},
		"RfcError": {
			"type": "object",
			"properties": {
				"type": {
					"type": "string"
				},
				"title": {
					"type": "string"
				}
			},
			"title": "RFC-7807 Based Error Schema"
		},
		"createAccessKeyResponse": {
			"type": "object",
			"properties": {
				"nrn": {
					"type": "string",
					"description": "nrn for AccessKey"
				},
				"accessKey": {
					"type": "string",
					"description": "AccessKey identifier"
				},
				"secret": {
					"type": "string",
					"description": "Sectet for AccessKey"
				}
			},
			"title": "create AccessKey Response"
		},
		"loginRequest": {
			"type": "object",
			"properties": {
				"idToken": {
					"type": "string",
					"description": "A JSON Web Token (JWT)"
				},
				"code": {
					"type": "string",
					"description": "The authorization code"
				},
				"accessKey": {
					"type": "string",
					"description": "The authorization access key"
				},
				"secret": {
					"type": "string",
					"description": "The authorization secret"
				},
				"global": {
					"type": "boolean",
					"description": "Determines if the account is using globalization"
				},
				"region": {
					"type": "string",
					"description": "The region where the account information will be stored"
				}
			},
			"title": "Login Request"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/ProjectCtrAdmin/prod-iad-cloud-client-api-v1-swagger.json
 ** module id = 1384
 ** module chunks = 0
 **/